import React from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { isMobile } from 'react-device-detect';

import Button from '../../Button';
import Paragraph from '../../Paragraph';
import Heading from '../../Heading';
import { Row } from '../Scaffold';
import renderField from '../../Inputs';
import Progress from '../../Progress';

const validate = (valueSet) => {
  const values = valueSet;
  const errors = { campaign: {} };

  if (!values.campaign) values.campaign = {};
  if (!values.campaign.activity_times) errors.campaign.activity_times = 'Please enter your activity level';

  return errors;
};

const inputTypes = [window.HTMLInputElement, window.HTMLSelectElement, window.HTMLTextAreaElement];

const triggerInputChange = (node, value = 0) => {
  if (inputTypes.indexOf(node.__proto__.constructor) > -1) {
    const setValue = Object.getOwnPropertyDescriptor(node.__proto__, 'value').set;

    const event = document.createEvent('Event');
    event.initEvent('input', true, true);

    setValue.call(node, value);
    node.dispatchEvent(event);
  }
};

class WeeklyActivityLevel extends React.PureComponent {
  state = {
    activityTimes: this.props.activity,
  };

  componentDidMount() {
    if (window.pageYOffset > this.sectionRef.offsetTop) {
      window.scrollTo({ top: this.sectionRef.offsetTop, behavior: 'smooth' });
    }

    if (!isMobile) { triggerInputChange(this.inputRef); }
  }

  render() {
    const { handleSubmit } = this.props;
    return (
      <Row classes="compaign-page activity-level" setRef={(sectionRef) => { this.sectionRef = sectionRef; }}>
        <div className="campaign-bg blue">
          <svg width="800" height="800" viewBox="0 0 800 800" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M-191.538 1736.18s948.537-475.5 1124.563-1274.192c176.025-798.691-159.68-1553.548-159.68-1553.548S-559.786 393.866-191.538 1736.18z" className="svg_bg_1" />
            <path d="M-453.085 1609.5s686.975 166.29 1120.563-167.95c433.592-334.23 585.632-865.687 585.632-865.687S-64.2127 762.802-453.085 1609.5z" className="svg_bg_2" />
            <path d="M-453.235 1609.39S150.648 1239.78 223.1 697.465C295.553 155.149 27.7053-326.192 27.7053-326.192S-775.018 737.63-453.235 1609.39z" className="svg_bg_3" />
            <path d="M706.354-437.052C250.513-42.8394-467.631 720.706-453.084 1608.95c23.479-11.88 950.315-485.4 1124.109-1273.962 59.894-271.7576 60.543-538.441 35.329-772.04z" className="svg_bg_4" />
          </svg>
        </div>
        <Progress step="activity" />
        <Paragraph center>
          <img className="section-logo" src="/site/images/campaign/activity-icon.svg" alt="" width="50" height="50" />
        </Paragraph>

        <form onSubmit={handleSubmit} className="form-campaign">
          <Heading classes="header-text campaign-header-text" center>How active <br />are you?</Heading>
          <Paragraph classes="desc-text" center>How many days in the past week have you been active for<br /><strong>30 minutes or more</strong>?</Paragraph>
          { isMobile ?
            <Field
              name="campaign[activity_times]"
              type="radiogroup"
              params={{ dataKey: 'numDaysWeek', name: 'campaign[activity_times]' }}
              component={renderField}
              centered
            /> :
            <Field
              name="campaign[activity_times]"
              type="inputrange"
              params={{ dataKey: 'numDaysWeek', name: 'campaign[activity_times]' }}
              setRef={(inputRef) => { this.inputRef = inputRef; }}
              component={renderField}
              onChange={(e, activityTimes) => this.setState({ activityTimes })}
              centered
            />
          }
          <Button classes={['color-button blue']} label="Next" onClick={handleSubmit} />
        </form>
      </Row>
    );
  }
}

WeeklyActivityLevel.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
};

export default reduxForm({
  form: 'campaign',
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  validate,
})(WeeklyActivityLevel);



// WEBPACK FOOTER //
// ./src/Components/Campaign/FormPages/WeeklyActivityLevel.jsx